import React, { createContext, useReducer, useEffect, useContext } from 'react'
import reducer, { SCREEN_STATES } from './reducer'
import { actionCreators } from './actions'
import { ApplicationContext } from '../../contexts/ApplicationContext'

import infoImageSrc from '@assets/images/cashflow_event_image.png'
import expenseImageSrc from '@assets/images/expense_image.png'

export const CashflowEventsContext = createContext({})

export const CashflowEventsProvider = (props) => {
  const { trackingDetails } = useContext(ApplicationContext)
  const [internalState, dispatch] = useReducer(
    reducer,
    initialState(props))
  const stateWithProps = { ...internalState, ...props }
  const actionsWithDispatch = actionCreators(dispatch, stateWithProps)
  const { updateProps } = actionsWithDispatch

  useEffect(
    () => updateProps(props),
    [props.cashflowEvents, props.editedProjectionData, props.riskProfile, props.expectedAge]
  )

  return (
    <CashflowEventsContext.Provider value={{ state: stateWithProps, trackingDetails, actions: actionsWithDispatch, props }}>
      {props.children}
    </CashflowEventsContext.Provider>
  )
}

const initialState = (props) => ({
  screen: SCREEN_STATES.OVERVIEW,
  cameFrom: null,
  eventType: null,
  joint: false,
  eventAttributes: undefined,
  formState: null,
  isFormValid: true,
  loading: false,
  cashflowEvents: props.cashflowEvents,
  infoImageSrc,
  expenseImageSrc,
})
